(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-localization"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSidebarLanguageSelector(scope) {
      var container = scope || document;
      var languageDisclosures = container.querySelectorAll('.js-language-disclosure');

      if (!languageDisclosures.length) return;

      languageDisclosures.forEach(function (disclosure) {
        if (disclosure.dataset.initialized === 'true') return;
        disclosure.dataset.initialized = 'true';

        var toggleBtn = disclosure.querySelector('.js-language-toggle');

        if (!toggleBtn) return;

        toggleBtn.addEventListener('click', function (event) {
          event.preventDefault();

          var isOpen = disclosure.classList.contains('is-open');

          document.querySelectorAll('.js-language-disclosure.is-open').forEach(function (item) {
            if (item !== disclosure) {
              item.classList.remove('is-open');

              var itemBtn = item.querySelector('.js-language-toggle');
              if (itemBtn) {
                itemBtn.setAttribute('aria-expanded', 'false');
              }
            }
          });

          disclosure.classList.toggle('is-open', !isOpen);
          toggleBtn.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initSidebarLanguageSelector(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initSidebarLanguageSelector(event.target);
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('.js-language-disclosure.is-open').forEach(function (disclosure) {
        if (!disclosure.contains(event.target)) {
          disclosure.classList.remove('is-open');

          var toggleBtn = disclosure.querySelector('.js-language-toggle');
          if (toggleBtn) {
            toggleBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
